import { fg } from '@atlassian/jira-feature-gating';

const getRemoteLinksQueryNew = () => `
    remoteLinks {
        isLinkingEnabled
        confluencePages {
            linkedPages {
				pageCount
				pages {
					... on ConfluencePage {
						id
						globalId
						href
						title
						type
					}
					... on FailedRemoteLink {
						id
						error
						link {
							id
							globalId
							href
						}
						repairLink { href }
					}
				}
            }
        }
		remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }
`;

const getRemoteLinksQueryOld = () => `
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }
`;

export const getRemoteLinksQuery = () =>
	fg('jiv_confluence_remote_link_critical_query')
		? getRemoteLinksQueryNew()
		: getRemoteLinksQueryOld();
